import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import { ReduceStore } from 'flux/utils';

class ReportScheduleStore extends ReduceStore {

    getInitialState() {
        return {isFetching: false, schedules: []};
    }

    getAll() {
        return this.getState().schedules;
    }

    getById(scheduleId) {
        return this.getState().schedules.find(({id}) => id === scheduleId);
    }

    isFetching() {
        return this.getInitialState().isFetching;
    }

    reduce(state, action) {
        switch (action.type) {
            case ActionTypes.REPORT_SCHEDULE_LIST_REQUEST:
                return {isFetching: true, schedules: state.schedules};

            case ActionTypes.REPORT_SCHEDULE_LIST_SUCCESS:
                return {isFetching: false, schedules: action.data};

            case ActionTypes.REPORT_SCHEDULE_LIST_FAILURE:
                return this.getInitialState();

            case ActionTypes.REPORT_SCHEDULE_INFO_SUCCESS:
                return {
                    isFetching: false,
                    schedules: [...state.schedules.filter(({id}) => id !== action.payload.scheduleId), action.data]
                };

            case ActionTypes.REPORT_SCHEDULE_ADD_SUCCESS:
                return {isFetching: false, schedules: [...state.schedules, action.data]}

            case ActionTypes.REPORT_SCHEDULE_UPDATE_SUCCESS:
                return {
                    isFetching: false,
                    schedules: [...state.schedules.filter(({id}) => id !== action.payload.scheduleId), action.data]
                };

            case ActionTypes.REPORT_SCHEDULE_DELETE_SUCCESS:
                return {isFetching: false, schedules: state.schedules.filter(({id}) => id !== action.payload.scheduleId)}

            default:
                return state;
        }
    }
}

export default new ReportScheduleStore(CentricDispatcher);
